<div fxLayout="row">
  <button
    [ngClass]="frame?.rtlEnabled ? 'icon_rtl' : ''"
    mat-icon-button
    [disabled]="isNavDisabled('decrement')"
    (click)="this.ticketsService.navigateContext(-1)"
  >
    <mat-icon class="icon" [svgIcon]="res.svgName('Navigation-ArrowLeft-Image')"></mat-icon>
  </button>
  <button
    [ngClass]="frame?.rtlEnabled ? 'icon_rtl' : ''"
    mat-icon-button
    [disabled]="isNavDisabled('increment')"
    (click)="this.ticketsService.navigateContext(1)"
  >
    <mat-icon class="icon" [svgIcon]="res.svgName('Navigation-ArrowRight-Image')"></mat-icon>
  </button>
</div>
